import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useContext, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, StyledInput } from '@ui';
import { useForm } from 'react-hook-form';
import FilterContext from '../Filter/FilterContext';

interface Props {
    filterName?: string;
    filterKey: string;
    callback?: () => void;
    size?: 'xs' | 'md';
    // Volle Spaltenbreite statt fixer 400px (Formular-Kontext)
    fullWidth?: boolean;
}

export const NumericFilter = ({ filterName, filterKey, callback, size = 'xs', fullWidth = false }: Props) => {
    const [filter, setFilter] = useContext(FilterContext);
    const { handleSubmit, register, reset } = useForm({ defaultValues: filter?.[filterKey] });

    useEffect(() => {
        reset(filter?.[filterKey]);
    }, [filter, filterKey, reset]);

    const handleSubmitFilter = (data) => {
        setFilter({ ...filter, [filterKey]: data });
        callback?.();
    };

    const resetFilter = () => {
        setFilter({ ...filter, [filterKey]: undefined });
        callback?.();
    };

    return (
        <form onSubmit={handleSubmit(handleSubmitFilter)}>
            <div
                className="tw-flex tw-w-full tw-items-baseline tw-gap-6 tw-px-2"
                style={{ minWidth: fullWidth || size !== 'xs' ? '100%' : 400 }}
            >
                {filterName && (
                    <b className="tw-min-w-[30%] tw-truncate tw-whitespace-nowrap tw-text-sm">{filterName}</b>
                )}
                <div className="tw-min-w-0 tw-flex-1">
                    <StyledInput
                        {...register('from')}
                        bordered
                        color="success"
                        type="number"
                        contentLeft={<span className="tw-whitespace-nowrap tw-text-sm tw-text-accents-6">von</span>}
                        size={size}
                        fullWidth
                    />
                </div>
                <div className="tw-min-w-0 tw-flex-1">
                    <StyledInput
                        {...register('to')}
                        bordered
                        color="success"
                        type="number"
                        size={size}
                        contentLeft={<span className="tw-whitespace-nowrap tw-text-sm tw-text-accents-6">bis</span>}
                        fullWidth
                    />
                </div>
                <div className="tw-flex tw-shrink-0 tw-gap-2">
                    <Button type="button" color="error" auto size={size} onPress={resetFilter}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>

                    <Button type="submit" color={filter?.[filterKey] ? 'warning' : 'success'} auto size={size}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                </div>
            </div>
        </form>
    );
};
